import React, { useState, useEffect } from "react";
import CommonPageHeader from "../../components/CommonPageHeader/CommonPageHeader";
import HomeFooter from "../Home/Home/HomeFooter/HomeFooter";
import HomeFact from "../Home/Home/HomeFact/HomeFact";
import HomeHeader from "../Home/Home/HomeHeader/HomeHeader";
import AboutAppoinment from "./AboutAppoinment/AboutAppoinment";
import AboutArea from "./AboutArea/AboutArea";
import AboutCounter from "./AboutCounter/AboutCounter";
import AboutTestimonial from "./AboutTestimonial/AboutTestimonial";
import AboutAnalysis from "./AboutAnalysis/AboutAnalysis";
import HomeFiveHowWorks from "../HomeFive/HomeFiveHowWorks/HomeFiveHowWorks";
import HomeThreeFaq from "../HomeThree/HomeThreeFaq/HomeThreeFaq";
import { buscarServico } from "../../hooks/getService";

const SOSGinecologistaOnline = () => {
  const [servicoData, setServicoData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const idArea = 1;
  const idServico = 4;

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const data = await buscarServico(idServico);
        if (data) {
          setServicoData(data);
        } else {
          console.error("Erro ao buscar dados do serviço.");
        }
      } catch (error) {
        console.error("Erro na requisição:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [idServico]);

  // Formatter para moeda BRL
  const formatarMoeda = (valor) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(valor);
  };

  const title = servicoData?.Nome || "SOS Ginecologista Online";
  const descricao =
    "Porque sua saúde não pode esperar. Consulta rápida para aquele momento de aperto da mulher Olis. Conecte-se com uma ginecologista especialista agora e obtenha o cuidado que você merece, exatamente quando precisa.";

  // Calcula o preço baseado nos dados reais
  const precoAVista = servicoData?.Preco ? Number(servicoData.Preco) : 0;
  const parcela6x = servicoData?.Parcelas?.find(
    (p) => p.QuantidadeParcelas === 6
  )?.ValorParcela;
  const valorParcela6x = parcela6x ? Number(parcela6x) / 6 : 0;
  const price = servicoData
    ? `${formatarMoeda(precoAVista)} ou até 6x de ${formatarMoeda(
        valorParcela6x
      )}`
    : "Carregando preço...";

  const fatos = {
    titulo_fatos: "Encontre a solução para possíveis problemas",
    descricao_fatos:
      "Te ajudaremos com leituras e/ou pedidos de exames de urgência, como ultrassom transvaginal e ultrassom de mama. Se apresentar sintomas como corrimentos genitais, coceiras ou cheiros atípicos, cólicas menstruais, sangramentos irregulares ou gestacionais, vamos te ajudar a aliviar esses e outros sintomas e tratar as possíveis causas.",
    subtitulos: [
      {
        titulo: "Conveniência Máxima",
        subtitulo:
          "Evite filas e salas de espera. Agende uma consulta online e fale com uma médica através de videochamada, no conforto e segurança do seu lar.",
      },
      {
        titulo: "Aconselhamento Imediato",
        subtitulo:
          "Receba orientações claras e precisas sobre os próximos passos, tratamentos ou cuidados necessários, ajudando a aliviar a ansiedade e resolver a situação de emergência rapidamente.",
      },
    ],
  };

  const passos = [
    {
      titulo: "Agendamento do serviço",
      descricao: "Escolha o melhor horário para você",
    },
    {
      titulo: "Recebimento do Link de Atendimento, via Whatsapp",
      descricao: "Receba o link de atendimento",
    },
    {
      titulo: "Envio de exames prévios via WhatsApp, se houverem",
    },
    {
      titulo: "Consulta realizada por videochamada (~ 30 min)",
      descricao: "Converse com a gente",
    },
    {
      titulo:
        "Envio de exames prévios via link recebido pelo WhatsApp, se houverem",
      descricao: "Realize os exames",
    },
    {
      titulo:
        "Agendamento do retorno em até 15 dias para ver resultados de exames",
      descricao: "Aguarde o acompanhamento",
    },
  ];

  const imgUrl = "img/services/imagemsos.png";

  if (isLoading) {
    return (
      <>
        <HomeHeader />
        <div style={{ textAlign: "center", padding: "50px" }}>
          <h2>Carregando...</h2>
        </div>
        <HomeFooter />
      </>
    );
  }

  return (
    <>
      <HomeHeader />
      <AboutArea
        title={title}
        descricao={descricao}
        price={price}
        idArea={idArea}
        idServico={idServico}
        imgUrl={imgUrl}
      />
      <HomeFact fatos={fatos} />
      <AboutAppoinment passos={passos} />
      <HomeThreeFaq />
      <HomeFooter />
    </>
  );
};

export default SOSGinecologistaOnline;
